import { ChangeMatrixCommand } from "ags/commands/change-matrix-command";
import { Components } from "appworks/components/components";
import { PromptComponent } from "appworks/components/prompt/prompt-component";
import { PromptContentSubcomponent } from "appworks/components/prompt/prompt-content-subcomponent";
import { Layers } from "appworks/graphics/layers/layers";
import { gameState } from "appworks/model/game-state";
import { Services } from "appworks/services/services";
import { SoundService } from "appworks/services/sound/sound-service";
import { TransactionService } from "appworks/services/transaction/transaction-service";
import { EnterFreespinsState } from "slotworks/state-machine/standard/states/enter-freespins-state";

export class AgsEnterFreespinsState extends EnterFreespinsState {

    protected footerMessageKey = "fot.fs";

    public complete() {
        super.complete();
        Services.get(SoundService).customEvent("start_freespins");
    }

    public onEnter(): void {
        // TODO: This might come out as part of freespins trigger show wins state
        Services.get(TransactionService).setWinnings(gameState.getCurrentGame().getTotalWin()).execute();

        this.setupMatrixComponent();

        super.onEnter();
    }

    public onSkip(): void {
        Components.get(PromptComponent).forceComplete();
    }

    protected showPrompt(prompt?: PromptContentSubcomponent): void {
        if (!prompt) {
            prompt = new PromptContentSubcomponent(["freespinswin"], Infinity);
        }

        prompt.setClickToSkip(true);

        super.showPrompt(prompt);
    }

    protected setupMatrixComponent() {
        ChangeMatrixCommand(true);
    }

    protected changeBackground(): void {
        if (Layers.get("Background").hasScene("freespins")) {
            Layers.get("Background").setScene("freespins").execute();
        }
    }
}
